/* eslint-disable */
export default {
  createCallLog: 'Luo puheluloki',
  viewInSalesforce: 'Näytä Salesforcessa',
  createLog: 'Luo loki',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
